import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, FlexView } from '../components/common'
import { AppContext } from '../stores/AppStore'
import { StockContext } from 'stores/StockStore'
import PiecesPieChartCard from 'components/home/PiecesPieChartCard'
import SearchForm from 'containers/home/SearchForm'
import StockHistoryChartCard from 'containers/home/StockHistoryChartCard'
import styled from 'styled-components'
import { UserContext } from 'stores/UserStore'
import moment from 'moment'

const Grid = styled(FlexView)`
  flex: 1;
  width: 100%;
  display: grid;
  align-items: stretch;
  grid-template-columns: 25% 25% 50%;
  max-height: 500px;
  white-space: nowrap

  @media screen and (max-width: 700px) {
    grid-template-columns: 100%;
  }
`

const Span = styled.span`
  font-size: 12px;
  color:gray;
`

const Home = () => {
  const { t } = useTranslation()
  const { registryLog } = useContext(UserContext)
  const DEFAULT_URL = "services-stock/home"
  const { setPageSubtitle } = useContext(AppContext)
  const { getServiceStockData, pieces, materialStatusPieces, isLoading, date } = useContext(StockContext)

  useEffect(() => {
    //registryLogOld('client_in', DEFAULT_URL)
    registryLog(DEFAULT_URL, 'navigation', 'page_in')
    getServiceStockData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPageSubtitle(t('service.pageTitle'))
  }, [setPageSubtitle, t])


  return <>
    <Card alignSelf="stretch" padding="8px 16px">
      <FlexView style={{ whiteSpace: 'nowrap', display: 'inline' }} fontSize="big" fontWeight="bold" margin="0px 0px 16px">
        {t('service.formSearchTitle')}&nbsp;&nbsp;
        <Span>{moment.utc(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss') !== "Data inválida" ? moment.utc(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss') : ''}</Span>

      </FlexView>
      <SearchForm />
    </Card>
    <Grid>
      <PiecesPieChartCard title={t('service.pieChartMostPieces')} pieces={pieces} isLoading={isLoading} flex="1" />
      <PiecesPieChartCard title={t('service.pieChartPiecesByStatus')} pieces={materialStatusPieces} isLoading={isLoading} flex="1" />
      <StockHistoryChartCard flex="1" />
    </Grid>
  </>
}
export default Home
